export type ZoomTier = 'far' | 'medium' | 'near' | 'close';

export function tierForZoom(zoom: number): ZoomTier {
  if (zoom <= 7) return 'far';
  if (zoom <= 12) return 'medium';
  if (zoom <= 14) return 'near';
  return 'close';
}
